import { toast } from "react-hot-toast";

import { apiConnector } from "../apiConnector";
import { chatbotendpoints } from "../apis";

const {
  CHATBOT_API,
  TEACHER_CHATBOT_API,
  CURRICULUM_BOT_API,
  TEACHER_Q_N_A_CHATBOT_API,
  TEACHER_KEY_POINT_CHATBOT_API,
  CHECK_USAGE_LIMIT_API,
  INCREASE_USAGE_LIMIT_API,
} = chatbotendpoints;

export const checkUsageLimit = async () => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector("GET", CHECK_USAGE_LIMIT_API, null, {
      Authorization: `Bearer ${token}`,
    });

    if (!response) {
      throw new Error("No response from server");
    }

    const data = response.data;

    if (data.success) {
      // ✅ Allow to continue
      return true;
    } else {
      // ❌ Limit reached
      toast.error(data.message || "Usage limit reached");
      return false;
    }
  } catch (error) {
    console.error("CHECK USAGE API ERROR:", error?.response?.data || error);
    toast.error(
      error?.response?.data?.message || "Failed to check usage limit",
    );
    return false;
  }
};

export const incrementUsage = async () => {
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    const response = await apiConnector(
      "POST", // 👈 increment should be POST
      INCREASE_USAGE_LIMIT_API, // 👈 your new route
      null,
      {
        Authorization: `Bearer ${token}`,
      },
    );

    if (!response) {
      throw new Error("No response from server");
    }

    const data = response.data;

    if (data.success) {
      // ✅ Successfully incremented
      return true;
    } else {
      // ❌ Limit reached or blocked
      toast.error(data.message || "Usage limit reached");
      return false;
    }
  } catch (error) {
    console.error("INCREMENT USAGE API ERROR:", error?.response?.data || error);
    toast.error(error?.response?.data?.message || "Failed to increment usage");
    return false;
  }
};

//Student chatbot
export const chatbot = async ({
  query,
  conversationId,
  className,
  subjectName,
  chapterName,
}) => {
  // console.log("api", CHATBOT_API);
  let result = null;
  // const toastId = toast.loading("AI is thinking..");
  const token = JSON.parse(localStorage.getItem("token"));

  //console.log("query", query);
  //console.log("id", conversationId, className,subjectName,chapterName);

  // 1️⃣ CHECK LIMIT BEFORE CALLING AI
  const isAllowed = await checkUsageLimit();
  if (!isAllowed) {
    // If limit reached, checkUsageLimit already shows a toast error.
    // We simply abort the function and return null.
    return null;
  }

  try {
    const response = await apiConnector(
      "POST",
      CHATBOT_API,
      {
        query,
        conversationId,
        className,
        subjectName,
        chapterName,
      },
      {
        Authorization: `Bearer ${token}`,
      },
    );

    // console.log(
    //   "CHATBOT API RESPONSE............",
    //   response.data.data.response
    // );
    if (!response) {
      throw new Error("Could Not Update Section");
    }
    // console.log("chat api", response.data.data)
    result = response.data.data;

    // 2️⃣ INCREMENT USAGE ONLY AFTER A SUCCESSFUL AI RESPONSE
    await incrementUsage();
  } catch (error) {
    console.log("CHATBOT API ERROR............", error.response.data.message);
    toast.error(error.response.data.message);
  }
  //  toast.dismiss(toastId);
  return result;
};

//teacher chatbot
export const teacherchatbot = async ({
  query,
  conversationId,
  className,
  subjectName,
  chapterName,
}) => {
  //console.log("api", TEACHER_CHATBOT_API);
  let result = null;
  // const toastId = toast.loading("AI is thinking..");
  const token = JSON.parse(localStorage.getItem("token"));

  //console.log("query", query);
  //console.log("id", conversationId, className,subjectName,chapterName);
  try {
    const response = await apiConnector(
      "POST",
      TEACHER_CHATBOT_API,
      {
        query,
        conversationId,
        className,
        subjectName,
        chapterName,
      },
      {
        Authorization: `Bearer ${token}`,
      },
    );

    // console.log(
    //   "CHATBOT API RESPONSE............",
    //   response.data.data.response
    // );
    if (!response) {
      throw new Error("Could Not Update Section");
    }
    // console.log("chat api", response.data.data)
    result = response.data.data;
  } catch (error) {
    console.log("CHATBOT API ERROR............", error.response.data.message);
    toast.error(error.response.data.message);
  }
  //  toast.dismiss(toastId);
  return result;
};

export const teachersKeyPoints = async ({
  query,
  conversationId,
  className,
  subjectName,
  chapterName,
}) => {
  //console.log("api", TEACHER_CHATBOT_API);
  let result = null;
  // const toastId = toast.loading("AI is thinking..");
  const token = JSON.parse(localStorage.getItem("token"));

  //console.log("query", query);
  //console.log("id", conversationId, className,subjectName,chapterName);
  try {
    const response = await apiConnector(
      "POST",
      TEACHER_KEY_POINT_CHATBOT_API,
      {
        query,
        conversationId,
        className,
        subjectName,
        chapterName,
      },
      {
        Authorization: `Bearer ${token}`,
      },
    );

    // console.log(
    //   "CHATBOT API RESPONSE............",
    //   response.data.data.response
    // );
    if (!response) {
      throw new Error("Could Not Update Section");
    }
    // console.log("chat api", response.data.data)
    result = response.data.data;
  } catch (error) {
    console.log("CHATBOT API ERROR............", error.response.data.message);
    toast.error(error.response.data.message);
  }
  //  toast.dismiss(toastId);
  return result;
};

export const teachersQuestionAnswerGeneration = async ({
  query,
  conversationId,
  className,
  subjectName,
  chapterName,
}) => {
  //console.log("api", TEACHER_CHATBOT_API);
  let result = null;
  // const toastId = toast.loading("AI is thinking..");
  const token = JSON.parse(localStorage.getItem("token"));

  //console.log("query", query);
  //console.log("id", conversationId, className,subjectName,chapterName);
  try {
    const response = await apiConnector(
      "POST",
      TEACHER_Q_N_A_CHATBOT_API,
      {
        query,
        conversationId,
        className,
        subjectName,
        chapterName,
      },
      {
        Authorization: `Bearer ${token}`,
      },
    );

    // console.log(
    //   "CHATBOT API RESPONSE............",
    //   response.data.data.response
    // );
    if (!response) {
      throw new Error("Could Not Update Section");
    }
    // console.log("chat api", response.data.data)
    result = response.data.data;
  } catch (error) {
    console.log("CHATBOT API ERROR............", error.response.data.message);
    toast.error(error.response.data.message);
  }
  //  toast.dismiss(toastId);
  return result;
};

export const CurriculmnSchoolAdmin = async ({
  query,
  conversationId,
  className,
  subjectName,
  chapterName,
}) => {
  // console.log("api", CURRICULUM_BOT_API);
  let result = null;
  // const toastId = toast.loading("AI is thinking..");
  const token = JSON.parse(localStorage.getItem("token"));

  //  console.log("query", query);
  // console.log("id", conversationId, className,subjectName,chapterName);
  try {
    const response = await apiConnector(
      "POST",
      CURRICULUM_BOT_API,
      {
        query,
        conversationId,
        className,
        subjectName,
        chapterName,
      },
      {
        Authorization: `Bearer ${token}`,
      },
    );

    // console.log(
    //   "CHATBOT API RESPONSE............",
    //   response.data.data.response
    // );
    if (!response) {
      throw new Error("Could Not Update Section");
    }
    // console.log("chat api", response.data.data)
    result = response.data.data;
  } catch (error) {
    console.log("CHATBOT API ERROR............", error.response.data.message);
    toast.error(error.response.data.message);
  }
  //  toast.dismiss(toastId);
  return result;
};
